import { mezclarFavoritos } from './favoritos';
import type { PreferenciasConfig, PreferenciasServidor } from './types';

/** Cómo resolver una edición simultánea de las preferencias (409 `version_desfasada`). */
export type OpcionConflicto = 'servidor' | 'local' | 'mezclar';

/**
 * Configuración resultante de resolver un conflicto:
 *  - 'servidor': se adopta la de la cuenta,
 *  - 'local': se conserva la de este dispositivo (se subirá sobre la versión del servidor),
 *  - 'mezclar': ajustes de este dispositivo con la unión de los favoritos de ambos lados.
 */
export function resolverConflicto(
  local: PreferenciasConfig,
  servidor: PreferenciasServidor,
  opcion: OpcionConflicto,
): PreferenciasConfig {
  if (opcion === 'servidor') return servidor.config;
  if (opcion === 'local') return local;
  return { ...local, favoritos: mezclarFavoritos(local.favoritos, servidor.config.favoritos) };
}

/** ¿Dos configuraciones son iguales? (para no preguntar cuando local y servidor coinciden). */
export const mismaConfig = (a: PreferenciasConfig, b: PreferenciasConfig): boolean =>
  JSON.stringify(a) === JSON.stringify(b);
